export const API_RESOURCE = {
  ADMIN_FUNCTIONS: 'admin',
  APPLICATION: 'applications',

  APPLICATION_TYPE: 'applicationTypes',
  AUTH: 'auth',
  CONFIG: 'configs',
  CONTRIBUTOR_GROUP: 'contributorGroups',
  COST_CENTER: 'costCenters',
  CUSTOMER: 'customers',
  DELEGATION: 'delegations',
  FILE: 'files',
  FRAME_AGREEMENT: 'frameAgreements',
  GCK_CODE: 'GCKCodes',
  OFFER: 'offers',
  RULE: 'rules',
  SLA: 'SLAs',
  VENDOR: 'vendors',
  SYSTEM_VARIABLE: 'systemVariables',
  USER: 'users',
  REASON_CONFIG: 'reasonConfigs',
  TABLE_PROFILE: 'tableProfiles',
  USER_TABLE_PROFILE: 'userTableProfiles',
  OFFER_COST_BUDGET: 'offerCostBudgets',
  GC_MATERIAL: 'GCMaterials',
  ANNOUNCEMENT: 'announcements',
  DOCUMENT_TEMPLATE: 'documentTemplates',
  USER_MANUAL: 'userManuals',
}

export const ListStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}
